import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffScheduleRequestsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.approve = this.approve.bind(this);
    this.reprove = this.reprove.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/geral/escala/solicitacoes', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-success" value={cell} onClick={() => this.approve(cell)}>
          <i className="fa fa-fw fa-check"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={() => this.reprove()}>
          <i className="fa fa-fw fa-close"></i>
        </button>
      </div>
    );

    return botao;
  }
  reprove (staff_schedule_request_id) {
    var confirm = window.confirm(this.locale.Solicitacoes.ListaDeSolicitacoes.reprovar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/reprovacao/gestor/alteracao/escala', { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approve (staff_schedule_request_id) {
    var confirm = window.confirm(this.locale.Solicitacoes.ListaDeSolicitacoes.aprovar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aprovacao/gestor/alteracao/escala', { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Solicitacoes.ListaDeSolicitacoes.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.semSolicitacoes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        {/* <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>Ações</TableHeaderColumn> */}
        
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="creation_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.DataDeCriacao}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='300'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.NomeDoColaborador}</TableHeaderColumn>
        <TableHeaderColumn dataField="start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Inicio}</TableHeaderColumn>
        <TableHeaderColumn dataField="finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Fim}</TableHeaderColumn>
        <TableHeaderColumn dataField="reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='500'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Justificativa}</TableHeaderColumn>
        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="fleet_chief_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='300'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrota}</TableHeaderColumn>
        <TableHeaderColumn dataField="fleet_chief_answer_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrotaDataResposta}</TableHeaderColumn>
        <TableHeaderColumn dataField="fleet_chief_answer_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrotaAprovacao}</TableHeaderColumn>
        <TableHeaderColumn dataField="fleet_chief_answer_reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='350'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrotaJustificativa}</TableHeaderColumn>
        <TableHeaderColumn dataField="manager_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Administrativo}</TableHeaderColumn>
        <TableHeaderColumn dataField="manager_answer_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.AdministrativoDataResposta}</TableHeaderColumn>
        <TableHeaderColumn dataField="manager_answer_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.AdministrativoAprovacao}</TableHeaderColumn>
        <TableHeaderColumn dataField="manager_answer_reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='350'>{this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.AdministrativoResposta}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffScheduleRequestsIndex;



// WEBPACK FOOTER //
// ./src/Components/StaffScheduleRequests/StaffScheduleRequestsIndex.js